var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchiveStackLine = function SvgArchiveStackLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75716B",
    d: "M3.333 4.167h13.334V2.5H3.333zM16.667 7.5H3.333V5.833h13.334zM2.5 9.167h5.833v1.666h3.334V9.167H17.5v7.5c0 .46-.373.833-.833.833H3.333a.833.833 0 0 1-.833-.833zm10.833 1.666V12.5H6.667v-1.667h-2.5v5h11.666v-5z"
  })));
};
export default SvgArchiveStackLine;